const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Constants");
const Card = require("./Card");

class PactCard extends Card{
    constructor(pact)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.Pact,
            null,
            pact.GetName(),
            pact.GetAge(),
            pact.GetText(),
            pact.GetEffects(),
        )
        this.pact = pact;
    }
}

module.exports = PactCard;